import { useEffect } from 'react';
import { isMobile } from '@/utils/mobile-compatibility';

export function SuiTokenLauncher() {
  useEffect(() => {
    // Set page title
    document.title = 'SUI Token Launcher | MDBApp';
    
    // On mobile/Android app, redirect directly to avoid iframe issues
    if (isMobile) {
      window.location.href = 'https://suitokenlauncher.app';
    }
  }, []);

  // If mobile, show loading message while redirecting
  if (isMobile) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-lg">Redirecting to SUI Token Launcher...</p>
        </div>
      </div>
    );
  }

  // Desktop: show iframe
  return (
    <div className="fixed inset-0 w-full h-full">
      <iframe
        src="https://suitokenlauncher.app"
        className="w-full h-full border-0"
        title="SUI Token Launcher"
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-modals"
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}
